const PATH = 'fe.components.organization.status_badge';

const messages = {
  accepted: {
    key: `${PATH}.accepted`,
    defaultValue: 'Active'
  },
  invited: {
    key: `${PATH}.invited`,
    defaultValue: 'Invited'
  },
  uploaded: {
    key: `${PATH}.uploaded`,
    defaultValue: 'Uploaded'
  }
};

export default messages;
